module.exports = __webpack_public_path__ + "img/info-3.9c8a16f5.jpg";